import { ExpirationType } from '../enums/expiration-type.enum';
import { IExpirationResponse, IIntervalExpirationResponse } from '../models/risk-assessment.model';

export function getIntervalExpiration(
  expiration?: IExpirationResponse | null
): IIntervalExpirationResponse | null {
  if (!expiration) {
    return null;
  }
  if (expiration.intervalExpiration) {
    return expiration.intervalExpiration;
  }
  if (expiration.type !== ExpirationType.IntervalExpiry) {
    return null;
  }
  return {
    alert: expiration.alert ?? '',
    interval: expiration.interval ?? 0,
    expiryDate: expiration.expiryDate as Date,
  };
}
